import React, { useEffect, useState } from 'react';
import {
  NativeSelect,
  TextField,
  Box,
  FormControl,
  Stack,
  Divider,
  Typography,
  Button,
} from '@mui/material';

import { toast } from 'react-toastify';
import moment from 'moment';

import api from '../../../../api/api';
import { useAuthState } from '../../../../contexts/AuthContext';
import Spinner from '../../../../components/Spinner/Spinner';
import TabelaResultados from './TabelaResultados/TabelaResultados';
import TitlePage from '../../../../components/TitlePage/TitlePage';
import RefreshIcon from '@mui/icons-material/Refresh';
import { ImprimePedidoProducao } from '../../../../components/ImprimePedidoProducao/ImprimePedidoProducao';

const Estoque = () => {
  const { empresaAtiva, usuarioIDLogado } = useAuthState();
  const [loading, setLoading] = useState(false);
  const [listaOrdens, setListaOrdens] = useState([]);
  const [listaClientes, setListaClientes] = useState([]);
  const [listaMaquinas, setListaMaquinas] = useState([]);
  const [dataInicio, setDataInicio] = useState(moment().format('YYYY-MM-DD'));
  const [dataFim, setDataFim] = useState(moment().format('YYYY-MM-DD'));
  const [tipoFiltro, setTipoFiltro] = useState('');
  const [clienteSelecionado, setClienteSelecionado] = useState();
  const [maquinaSelecionada, setMaquinaSelecionada] = useState(0);
  const [ordensFiltradas, setOrdensFiltradas] = useState([]);
  const [atualizaFiltro, setAtualizaFiltro] = useState(false);
  const [producaoSelecionada, setProducaoSelecionada] = useState();
  const [openDialogImprimePedido, setOpenDialogImprimePedido] = useState(false);
  const [parametroFiltro, setParametroFiltro] = useState({
    emissaoInicio: '',
    emissaoFim: '',
    entregaInicio: '',
    entregaFim: '',
    cliente: '',
    clicheria: '',
    status: 'ESTOQUE',
    maquina: '',
  });

  useEffect(() => {
    const buscaDados = async () => {
      setLoading(true);
      try {
        await Promise.all([
          buscarEtapas(),
          buscarClientes(),
          buscarProducoes(),
        ]);
      } catch (error) {
        console.error('Erro ao Buscar Dados:', error);
        toast.error('Erro geral ao buscar dados');
      } finally {
        setLoading(false);
      }
    };
    buscaDados();
  }, [parametroFiltro, empresaAtiva, atualizaFiltro]);

  const selecionaFiltro = (tipoFiltro) => {
    setTipoFiltro(tipoFiltro.tipoFiltro);
    setClienteSelecionado(tipoFiltro.cliente);
    switch (tipoFiltro.tipoFiltro) {
      case 'emissao':
        setParametroFiltro({
          emissaoInicio: dataInicio,
          emissaoFim: dataFim,
          entregaInicio: '',
          entregaFim: '',
          cliente: '',
          clicheria: '',
          status: 'ESTOQUE',
          maquina: '',
        });
        break;

      case 'entrega':
        setParametroFiltro({
          emissaoInicio: '',
          emissaoFim: '',
          entregaInicio: dataInicio,
          entregaFim: dataFim,
          cliente: '',
          clicheria: '',
          status: 'ESTOQUE',
          maquina: '',
        });
        break;
      case 'cliente':
        setParametroFiltro({
          emissaoInicio: '',
          emissaoFim: '',
          entregaInicio: '',
          entregaFim: '',
          clicheria: '',
          cliente: tipoFiltro.cliente,
          status: 'ESTOQUE',
          maquina: '',
        });
        break;
      default:
        setParametroFiltro({
          emissaoInicio: '',
          emissaoFim: '',
          entregaInicio: '',
          entregaFim: '',
          cliente: '',
          clicheria: '',
          status: 'ESTOQUE',
          maquina: '',
        });
    }
  };

  async function buscarEtapas() {
    try {
      const { data } = await api.get('/producao/lista/etapas', {
        headers: {
          banco: empresaAtiva,
        },
      });
      console.log(data);
      setListaMaquinas(data);
      return data;
    } catch (error) {
      toast.error('Erro ao buscar Maquinas');
      console.log(error);
    }
  }

  async function buscarProducoes() {
    try {
      const { data } = await api.post('/producao/lista', parametroFiltro, {
        headers: { banco: empresaAtiva },
      });
      setListaOrdens(data);
      setOrdensFiltradas(data);
    } catch (error) {
      toast.error('Erro ao buscar Produções');
      console.log(error);
    }
  }

  async function buscarClientes() {
    try {
      const { data } = await api.get('/cliente/lista1', {
        headers: {
          banco: empresaAtiva,
        },
      });
      setListaClientes(data);
    } catch (error) {
      toast.error('Erro ao buscar Clientes');
      console.log(error);
    }
  }

  const baixaEstoque = (producao) => {
    setLoading(true);
    api
      .put(
        '/producao/estoque/baixar',
        {
          producao: producao,
          usuario: usuarioIDLogado,
        },
        {
          headers: { banco: empresaAtiva },
        },
      )
      .then(() => {
        toast.success('Producão alterada com sucesso ');
        setAtualizaFiltro(!atualizaFiltro);
        abrirDialogImprimePedido(producao);
      })
      .catch((err) => {
        toast.success('Erro ao  alterar Producao ', err.response.data.Message);
        console.log(err);
        setAtualizaFiltro(!atualizaFiltro);
      });
  };
  const abrirDialogImprimePedido = (producao) => {
    setOpenDialogImprimePedido(true);
    setProducaoSelecionada(producao);
  };

  const fecharDialogImprimePedido = () => {
    setProducaoSelecionada(null);
    setOpenDialogImprimePedido(false);
    setAtualizaFiltro(!atualizaFiltro);
  };

  const filtroPorMaquina = (e) => {
    console.log(e.target.value);
    if (e.target.value === '') {
      setMaquinaSelecionada(e.target.value);
      setAtualizaFiltro(!atualizaFiltro);
    } else {
      setLoading(true);
      setMaquinaSelecionada(e.target.value);
      const novasOrdens = listaOrdens.filter(
        (ordem) =>
          ordem.opr_cd_maq01 === Number(e.target.value) ||
          ordem.opr_cd_maq02 === Number(e.target.value),
      );
      setOrdensFiltradas(novasOrdens);
      setLoading(false);
    }
  };

  if (loading) {
    return <Spinner />;
  }

  return (
    <>
      <Box>
        <TitlePage title="Separação de Materia Prima" />
        <Box>
          <Box marginLeft={'6%'}>
            <Typography variant="subtitle2">Período </Typography>
          </Box>

          <Stack
            direction={{ xs: 'row', sm: 'row', md: 'row', lg: 'row' }}
            spacing={{ xs: 1, sm: 1, md: 3 }}
            mt={2}
            mb={2}
          >
            <Box width={'4%'} display={'flex'} justifyContent={'center'}>
              <Button
                onClick={() => setAtualizaFiltro(!atualizaFiltro)}
                sx={{
                  borderRadius: '50%',
                  width: '25%',
                  height: '100%',
                  backgroundColor: 'primary.success',
                }}
              >
                <RefreshIcon sx={{ color: 'white' }} />
              </Button>
            </Box>
            <Box width={'13%'}>
              <TextField
                fullWidth
                InputLabelProps={{ shrink: true }}
                label="Emissão Inicial "
                type="date"
                value={dataInicio}
                onChange={(e) => setDataInicio(e.target.value)}
              />
            </Box>
            <Box width={'13%'}>
              <TextField
                fullWidth
                InputLabelProps={{ shrink: true }}
                label="Emissão Final"
                type="date"
                value={dataFim}
                onChange={(e) => setDataFim(e.target.value)}
              />
            </Box>
            <Box width={'20%'}>
              <Box>
                <Typography variant="subtitle2">Filtra por Data</Typography>
              </Box>
              <NativeSelect
                value={tipoFiltro}
                fullWidth
                onChange={(e) =>
                  selecionaFiltro({ tipoFiltro: e.target.value })
                }
              >
                <option default value="">
                  Todos os Registros
                </option>
                <option value="emissao">Por Emissao</option>
                <option value="entrega">Por Data Entrega </option>
              </NativeSelect>
            </Box>
            <Box width={'25%'}>
              <Box>
                <Typography variant="subtitle2">Filtrar por Cliente</Typography>
              </Box>

              <FormControl fullWidth>
                <NativeSelect
                  fullWidth
                  value={clienteSelecionado}
                  onChange={(e) =>
                    selecionaFiltro({
                      tipoFiltro: 'cliente',
                      cliente: e.target.value,
                    })
                  }
                >
                  <option value="">Todos os Registros </option>
                  {listaClientes.length > 0 ? (
                    listaClientes.map((cliente) => {
                      return (
                        <option key={cliente.codigo} value={cliente.codigo}>
                          {cliente.nome_fantasia
                            ? cliente.nome_fantasia
                            : cliente.razao_social}
                        </option>
                      );
                    })
                  ) : (
                    <></>
                  )}
                </NativeSelect>
              </FormControl>
            </Box>
            <Box width={'25%'}>
              <Box>
                <Typography variant="subtitle2">Filtrar por Maquina</Typography>
              </Box>
              <FormControl fullWidth>
                <NativeSelect
                  fullWidth
                  value={maquinaSelecionada}
                  onChange={filtroPorMaquina}
                >
                  <option value="">Todos os Registros </option>
                  {listaMaquinas.length > 0 ? (
                    listaMaquinas.map((maquina) => {
                      return (
                        <option
                          key={maquina.maq_codigo}
                          value={maquina.maq_codigo}
                        >
                          {maquina.maq_descricao}
                        </option>
                      );
                    })
                  ) : (
                    <></>
                  )}
                </NativeSelect>
              </FormControl>
            </Box>
          </Stack>
        </Box>
        <Divider />
        {producaoSelecionada ? (
          <ImprimePedidoProducao
            open={openDialogImprimePedido}
            onClose={fecharDialogImprimePedido}
            producao={producaoSelecionada}
            tipo="estoque"
          />
        ) : (
          <></>
        )}
        <TabelaResultados
          listaOrdens={ordensFiltradas}
          baixaEstoque={baixaEstoque}
        />
      </Box>
    </>
  );
};

export default Estoque;
